<div class="adm-header" mat-dialog-title>
	<div class="adm-header-left">
		<span class="adm-code">{{ data.accountcode }}</span>
		<span class="adm-name">{{ data.accountname }}</span>
	</div>
	<div class="adm-header-right">
		<span class="adm-period-badge">{{ data.periodLabel }}</span>
		<button mat-icon-button (click)="close()" class="adm-close">
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>

<mat-dialog-content class="adm-body">

	<div *ngIf="loading" class="adm-loading">
		<svg class="adm-spinner" width="44" height="44" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" class="adm-spinner-circle"></circle>
		</svg>
	</div>

	<ng-container *ngIf="!loading">

		<div *ngIf="!transactions.length" class="adm-empty">
			<mat-icon class="adm-empty-icon">receipt_long</mat-icon>
			<p>No individual transactions recorded for this account in this period.</p>
			<div *ngIf="chartdetails" class="adm-breakdown">
				<div class="adm-breakdown-row">
					<span class="adm-breakdown-label">Opening Balance (B/Fwd)</span>
					<span class="adm-breakdown-val" [class.adm-neg]="chartdetails.bfwd < 0">{{ chartdetails.bfwd | currency }}</span>
				</div>
				<div class="adm-breakdown-row">
					<span class="adm-breakdown-label">Period Movement</span>
					<span class="adm-breakdown-val" [class.adm-neg]="chartdetails.actual < 0">{{ chartdetails.actual | currency }}</span>
				</div>
				<div class="adm-breakdown-row adm-breakdown-total">
					<span class="adm-breakdown-label">Closing Balance</span>
					<span class="adm-breakdown-val" [class.adm-neg]="chartdetails.balance < 0">{{ chartdetails.balance | currency }}</span>
				</div>
			</div>
		</div>

		<ng-container *ngIf="transactions.length">
			<table class="adm-table">
				<thead>
					<tr>
						<th class="col-type">Type</th>
						<th class="col-num">No.</th>
						<th class="col-date">Date</th>
						<th class="col-amount text-right col-debit">Debit</th>
						<th class="col-amount text-right col-credit">Credit</th>
						<th class="col-amount text-right col-balance-h">Balance</th>
						<th class="col-debtor">Customer</th>
						<th class="col-desc">Description</th>
						<th class="col-tag">Tag</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngIf="showOpeningBalanceRow()" class="adm-row adm-opening-row">
						<td class="col-type">B/Fwd</td>
						<td class="col-num">—</td>
						<td class="col-date">—</td>
						<td class="col-amount text-right amount-debit adm-debit"></td>
						<td class="col-amount text-right amount-credit adm-credit"></td>
						<td class="col-amount text-right col-balance" [class.adm-neg]="(openingBalance ?? 0) < 0">{{ openingBalance | number:'1.2-2' }}</td>
						<td class="col-debtor"></td>
						<td class="col-desc adm-opening-desc">Opening balance</td>
						<td class="col-tag"></td>
					</tr>
					<tr
						*ngFor="let t of transactions"
						class="adm-row"
						[class.adm-adjustment-row]="isAdjustmentRow(t)"
						(click)="onTransactionRowClick(t)">
						<td class="col-type">{{ t.type }}</td>
						<td class="col-num">{{ t.number }}</td>
						<td class="col-date">{{ t.trandate }}</td>
						<td class="col-amount text-right amount-debit adm-debit">{{ t.debit }}</td>
						<td class="col-amount text-right amount-credit adm-credit">{{ t.credit }}</td>
						<td class="col-amount text-right col-balance" [class.adm-neg]="t.balance && t.balance.toString().startsWith('-')">{{ t.balance }}</td>
						<td class="col-debtor">
							<ng-container *ngIf="t.debtorno || t.debtorname">
								<span class="adm-debtor-no" *ngIf="t.debtorno">{{ t.debtorno }}</span>
								<span *ngIf="t.debtorno && t.debtorname" class="adm-debtor-sep"> — </span>
								<span class="adm-debtor-name" *ngIf="t.debtorname">{{ t.debtorname }}</span>
							</ng-container>
						</td>
						<td class="col-desc">{{ t.narrative }}</td>
						<td class="col-tag">
							<span *ngIf="t.tag" class="adm-tag-badge">{{ t.tag }}</span>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr class="adm-total-row">
						<td colspan="3">Period Net</td>
						<td colspan="3" class="text-right adm-total-val" [class.adm-neg]="periodtotal < 0">
							{{ periodtotal | currency }}
						</td>
						<td></td>
						<td colspan="2"></td>
					</tr>
					<tr class="adm-balance-row">
						<td colspan="3">Closing Balance</td>
						<td colspan="3" class="text-right adm-balance-val" [class.adm-neg]="endbalance < 0">
							{{ endbalance | currency }}
						</td>
						<td></td>
						<td colspan="2"></td>
					</tr>
				</tfoot>
			</table>
		</ng-container>

	</ng-container>

	<p *ngIf="showUnpostedFinder()" class="adm-unposted-finder-hint text-muted small px-3 pb-2 mb-0">
		The &ldquo;Unposted from prior periods&rdquo; line is the net of <strong>unposted</strong> GL lines in
		<strong>earlier periods</strong> through this period end (they are not repeated in the table above).
		<button mat-button color="primary" type="button" class="ms-1" (click)="openAccountInquiryUnposted()">
			Show unposted lines
		</button>
	</p>

</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-stroked-button (click)="close()">Close</button>
</mat-dialog-actions>
